import api from '@/services/Api';

class ConferenceRoles {
  static me() {
    return api.get('/affiliates/me/conference-roles');
  }

  static show(affiliateId) {
    return api.get(`/public/affiliates/${affiliateId}/conference-roles`);
  }
}

export default ConferenceRoles;
